import script from "./Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Header.vue?vue&type=script&setup=true&lang=js"

import "./css/common.scss?vue&type=style&index=0&id=451bfa0c&scoped=true&lang=css"

import exportComponent from "/builds/macys/polaris/app/bag-and-checkout/bag-and-checkout-app/._tmpdirxxx/.node/lib/node_modules/@core/vue-cli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-451bfa0c"]])

export default __exports__